/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSouscriptionInformationsMutation($input: SaveSouscriptionInformations_M_souscription_informationsInput!) {
    saveSouscriptionInformations_M_souscription_informations(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
